<!--
 * @Descripttion: 
 * @version: 
 * @Author: 孙鑫鑫
 * @Date: 2022-03-10 14:29:42
 * @LastEditors: 孙鑫鑫
 * @LastEditTime: 2022-03-10 15:55:37
-->
<template>
  <el-drawer
    title="我是标题"
    :visible="show"
    :direction="'rtl'"
    :withHeader="false"
    custom-class="DrawerUrl"
    size="935px"
  >
    <div class="drawBox">
      <div class="phoneimg">
        <div class="framebox">
          <iframe class="iframe" :src="urlMobile" frameborder="0"></iframe>
        </div>
      </div>
      <div class="titlebox">
        <div class="title">
          <div class="label">预览</div>
          <img
            src="../../assets/new/close.png"
            class="closeIcon"
            @click="$emit('close', false)"
          />
        </div>
        <slot name="title"></slot>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: "",
    },
    urlMobile: {
      type: String,
      default: "",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<style>
.DrawerUrl {
  box-shadow: none;
  background-color: transparent !important;
  min-width: 500px !important;
}
</style>
<style lang="scss" scoped>
/deep/.el-drawer {
  width: 935px !important;
  padding-right: 25px;
}

/deep/ .el-drawer__body {
  background-color: transparent !important;
}

.titlebox {
  width: 563px;
  background: #fff;
  border-radius: 6px;
  padding: 24px;
  margin-top: -306px;

  .title {
    font-size: 18px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    position: relative;

    .label {
      color: #333333;
      font-family: "PingFang SC";
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
    }

    .closeIcon {
      height: 32px;
      cursor: pointer;
      position: absolute;
      right: -24px;
      top: -80px;
    }
  }
}

.drawBox {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.phoneimg {
  width: 320px;
  height: 670.48px;
  background-image: url("../../assets/script/preview.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 48px 17px 25px;
  flex-shrink: 0;
  margin-right: 27px;
}

.framebox {
  width: 100%;
  height: 90.5%;
}

.iframe {
  width: 100%;
  height: 100%;
  border-radius: 30px;
}
</style>
